import { createSelector } from 'reselect';
import { serverSpaceItems } from '@src/containers/SpacesListing/selectors';

export const getSpacesBounds = createSelector(serverSpaceItems, (items) => {
	const initLng = items[0]?.coordinate?.longitude || 0;
	const initLat = items[0]?.coordinate?.latitude || 0;

	if (items.length === 0) return null;

	const nw = { lat: initLat, lng: initLng };
	const se = { lat: initLat, lng: initLng };

	items.forEach((i) => {
		const lat = i.coordinate?.latitude;
		const lng = i.coordinate?.longitude;

		if (nw.lat < lat) nw.lat = lat;
		if (nw.lng > lng) nw.lng = lng;
		if (se.lat > lat) se.lat = lat;
		if (se.lng < lng) se.lng = lng;
	});

	return {
		nw,
		se,
	};
});
